export default function Logo({ size = 80, showTagline = true }) {
  return (
    <div className="flex flex-col items-center" data-testid="itcot-logo">
      <img
        src="https://customer-assets.emergentagent.com/job_73913346-f729-45a1-8fb0-7af06a2fb929/artifacts/r2z2q29s_logo.jpg"
        alt="ITCOT Logo"
        style={{ height: size, width: "auto" }}
        className="object-contain"
      />
      {showTagline && (
        <p className="mt-2 text-[10px] tracking-[0.18em] font-semibold text-[#1A3A5C]">
          ENABLING ENTERPRISES SINCE 1979
        </p>
      )}
    </div>
  );
}
